<template>
  <div class="EnterpriseSeriesList">
    <XTable
        ref="xTable"
        :api="getClassSubjectList"
        :state="classSubjectList"
        :columns="columns"
        :loading="classSubjectListLoading"
        :tableSize="tableSize"
        :layout="layout"
    ></XTable>
  </div>
</template>

<script>
import XTable from "@/components/XTable/index.vue";
import {mapActions, mapMutations, mapState} from "vuex";
import DateUtil from "@/utils/formatDate";
import {SERIES_STATES} from "@/utils/constants";
import AppTable from "@/components/ui/AppTable/index.vue";

export default {
  name: "EnterpriseSeriesList",
  components: {AppTable, XTable},
  data() {
    return {
      tableSize: "small",
      layout: "sizes, prev, pager, next",
    };
  },
  computed: {
    ...mapState("teachingCenter", [
      "classSubjectList",
      "classSubjectListLoading",
    ]),
    ...mapState("user", ["permissionCode"]),
    columns: function () {
      const self = this;
      const columns = [
        {
          prop: "id",
          label: "系列编号",
        },
        {
          prop: "name",
          minWidth: "130",
          label: "系列名称",
        },
        // {
        //   label: "封面图",
        //   minWidth: "90",
        //   render(h, scope) {
        //     return (
        //         <div class="box">
        //           {scope.row && scope.row.materialUrl && (
        //               <img className="setPic" src={scope.row.materialUrl} alt=""/>
        //           )}
        //           {scope.row && !scope.row.materialUrl && <span>-</span>}
        //         </div>
        //     );
        //   },
        // },
        {
          prop: "classTreeName",
          minWidth: "130",
          label: "上级目录",
        },
        {
          prop: "classNumber",
          label: "课程数量",
        },
        // {
        //   label: "做课进度",
        //   width: 120,
        //   render(h, scope) {
        //     return (
        //         <div>
        //       <span>
        //         {(scope.row && scope.row.classNumber) || 0}/
        //         {(scope.row && scope.row.totalClass) || 0}
        //       </span>
        //         </div>
        //     );
        //   },
        // },
        // {
        //   label: "上架日期",
        //   render(h, scope) {
        //     return (
        //       <div>
        //         <span>{self.formatDate(scope.row.startTime)}</span>
        //       </div>
        //     );
        //   },
        // },
        // {
        //   label: "下架日期",
        //   render(h, scope) {
        //     return (
        //       <div>
        //         <span>{self.formatDate(scope.row.endTime)}</span>
        //       </div>
        //     );
        //   },
        // },
        {
          label: "状态",
          width: 100,
          render(h, scope) {
            return (
                <div>
                  <span>{SERIES_STATES[scope.row.states]}</span>
                </div>
            );
          },
        },
        // <el-button
        //     onClick={() => {
        //       self.handleAddStudent(scope.row);
        //     }}
        //     size="mini"
        //     type="primary"
        //     plain
        // >
        //   新增学员
        // </el-button>
        // <el-dropdown>
        //             <span class="el-dropdown-link">
        //               更多<i class="el-icon-arrow-down el-icon--right"></i>
        //             </span>
        //   <el-dropdown-menu slot="dropdown">
        //     <el-dropdown-item
        //         nativeOnClick={() => {
        //           self.handleShare(scope.row);
        //         }}
        //     >
        //       分享
        //     </el-dropdown-item>
        //     {scope.row.states !== 1 && (
        //         <el-dropdown-item
        //             nativeOnClick={() => {
        //               self.handleDelete(scope.row);
        //             }}
        //         >
        //           删除
        //         </el-dropdown-item>
        //     )}
        //     <el-dropdown-item
        //         nativeOnClick={() => {
        //           self.handleDownShare(scope.row);
        //         }}
        //     >
        //       下发
        //     </el-dropdown-item>
        //   </el-dropdown-menu>
        // </el-dropdown>
      ];
      if (this.permissionCode.has('research:subject:manager')) {
        let lessonList = this.permissionCode.has('lesson:manager:list');
        columns.push({
          label: "操作",
          fixed: "right",
          width: 300,
          render(h, scope) {
            return (
                <div>
                  {!scope.row.noEdit && (
                      <el-button
                          onClick={() => {
                            self.handleEdit(scope.row);
                          }}
                          size="mini"
                          type="primary"
                          plain
                      >
                        编辑
                      </el-button>
                  )}
                  {scope.row.states === 1 && !scope.row.noEdit && (
                      <el-button
                          onClick={() => {
                            self.handleDeployDown(scope.row);
                          }}
                          size="mini"
                          type="primary"
                          plain
                      >
                        下架
                      </el-button>
                  )}
                  {scope.row.states === 0 && !scope.row.noEdit && (
                      <el-button
                          onClick={() => {
                            self.handleDeployUp(scope.row);
                          }}
                          size="mini"
                          type="primary"
                          plain
                      >
                        上架
                      </el-button>
                  )}
                  {lessonList === true && (<el-button
                      onClick={() => {
                        self.handleView(scope.row);
                      }}
                      size="mini"
                      type="primary"
                      plain
                  >
                    查看课程
                  </el-button>)
                  }
                  {!scope.row.noEdit && (
                      <el-button
                          onClick={() => {
                            self.handleDelete(scope.row);
                          }}
                          size="mini"
                          type="danger"
                          plain
                      >
                        删除
                      </el-button>
                  )}
                </div>
            );
          },
        })
      }
      return columns;
    }
  },
  methods: {
    ...mapActions("teachingCenter", [
      "getClassSubjectList",
      "deleteClassSubject",
      "deployClassSubject",
    ]),
    ...mapMutations("teachingCenter", ["setData"]),
    async handleEdit(row) {
      localStorage.setItem("classSubjectDetail", JSON.stringify(row));
      await this.$router.push(
          {
            name: "AddEnterpriseSeries",
            params: {
              type: "edit",
              id: 0,
            },
          },
          () => {
          }
      );
    },
    // 下架
    async handleDeployDown(row) {
      this.$confirm("请确认是否要下架该系列课程?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(async () => {
            await this.deployClassSubject({
              id: row.id,
              states: 0,
            });

            this.$message.success("操作成功");
            this.$refs.xTable.pageChange();
          })
          .catch(() => {
          });
    },
    // 上架
    async handleDeployUp(row) {
      this.$confirm("请确认是否要上架该系列课程?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(async () => {
            await this.deployClassSubject({
              id: row.id,
              states: 1,
            });
            this.$message.success("操作成功");
            this.$refs.xTable.pageChange();
          })
          .catch(() => {
          });
    },
    handleAddStudent(row) {
      console.log(row);
    },
    handleShare(row) {
      console.log(row);
    },
    async handleDelete(row) {
      console.log(row);
      if (row.classNumber > 0) {
        this.$confirm(
            "删除系列将会同步删除系列下课程内容，是否确认删除?",
            "提示",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            }
        )
            .then(async () => {
              await this.deleteClassSubject({
                id: row.id,
              });
              this.$refs.xTable.pageChange();
            })
            .catch(() => {
            });
      } else {
        this.$confirm("请确认是否删除系列?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
            .then(async () => {
              await this.deleteClassSubject({
                id: row.id,
              });
              this.$refs.xTable.pageChange();
            })
            .catch(() => {
            });
      }
    },
    async handleView(row) {
      await this.$router.push(
          {
            name: "CourseList",
            params: {
              classSubjectId: this.$Base64.encode(row.id),
              classSubjectName: this.$Base64.encode(row.name),
              classTreeId: this.$Base64.encode(row.classTreeId),
            },
          },
          () => {
          }
      );
    },
    handleDownShare(row) {
      console.log(row);
    },
    //   根据时间戳计算开课日期、结课日期
    formatDate(timestamp) {
      return DateUtil.formatDateFromTimestamp(timestamp);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/variables";

.EnterpriseSeriesList {
  ::v-deep .box {
    line-height: 28px;
    height: 28px;
  }

  ::v-deep img {
    width: 40px !important;
    height: 28px !important;
    line-height: 28px !important;
  }

  ::v-deep .el-dropdown-link {
    cursor: pointer;
    color: map-get($colors, primary);
    margin-left: 10px;

    ::v-deep .el-icon-arrow-down {
      font-size: 12px;
    }
  }
}
</style>
